import React from "react";

// Feature 1: Product Reviews — campaign card with image, category badge, compensation, spots, apply button
// Mirrors the actual influencer campaign card UI
export const ProductReviewsSVG = () => (
  <svg viewBox="0 0 400 300" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <defs>
      <linearGradient id="rv-bg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#f8fafc" />
        <stop offset="100%" stopColor="#eff6ff" />
      </linearGradient>
      <linearGradient id="rv-img" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#3B5BA5" />
        <stop offset="100%" stopColor="#60A5FA" />
      </linearGradient>
    </defs>
    <rect width="400" height="300" fill="url(#rv-bg)" rx="12" />

    {/* Campaign card */}
    <rect x="50" y="30" width="300" height="240" fill="#ffffff" rx="10" stroke="#e2e8f0" strokeWidth="1" />

    {/* Campaign image header */}
    <rect x="50" y="30" width="300" height="80" fill="url(#rv-img)" rx="10" />
    <rect x="50" y="95" width="300" height="15" fill="url(#rv-img)" />

    {/* Category badge */}
    <rect x="62" y="42" width="60" height="18" rx="9" fill="#ffffff" fillOpacity="0.25" />
    <text x="92" y="54" fontSize="9" fill="#fff" fontWeight="600" textAnchor="middle" fontFamily="sans-serif">Fashion</text>

    {/* Compensation badge */}
    <rect x="280" y="42" width="58" height="18" rx="9" fill="#34d399" />
    <text x="309" y="54" fontSize="9" fill="#fff" fontWeight="700" textAnchor="middle" fontFamily="sans-serif">₱2,500</text>

    {/* Campaign title */}
    <rect x="62" y="125" width="180" height="7" rx="3.5" fill="#1e293b" />
    <rect x="62" y="138" width="140" height="5" rx="2.5" fill="#94a3b8" />

    {/* Description lines */}
    <rect x="62" y="155" width="260" height="4" rx="2" fill="#e2e8f0" />
    <rect x="62" y="164" width="240" height="4" rx="2" fill="#e2e8f0" />
    <rect x="62" y="173" width="200" height="4" rx="2" fill="#e2e8f0" />

    {/* Spots remaining */}
    <rect x="62" y="195" width="100" height="22" rx="6" fill="#fef2f2" />
    <circle cx="74" cy="206" r="4" fill="#ef4444" />
    <text x="84" y="210" fontSize="8" fill="#dc2626" fontWeight="600" fontFamily="sans-serif">3 spots left!</text>

    {/* Deadline */}
    <rect x="172" y="195" width="90" height="22" rx="6" fill="#f0f9ff" />
    <rect x="182" y="202" width="8" height="8" rx="2" fill="#3B5BA5" />
    <text x="196" y="210" fontSize="8" fill="#3B5BA5" fontWeight="600" fontFamily="sans-serif">Ends Aug 30</text>

    {/* Apply button */}
    <rect x="62" y="235" width="276" height="24" rx="8" fill="#3B5BA5" />
    <text x="200" y="251" fontSize="10" fill="#fff" fontWeight="700" textAnchor="middle" fontFamily="sans-serif">View Details & Apply</text>
  </svg>
);

// Feature 2: Monetize Your Influence — payments dashboard with earnings stats and payment history
// Mirrors the actual influencer Payments page
export const MonetizeSVG = () => (
  <svg viewBox="0 0 400 300" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <defs>
      <linearGradient id="mn-bg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#f0fdf4" />
        <stop offset="100%" stopColor="#ecfdf5" />
      </linearGradient>
      <linearGradient id="mn-card1" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#10b981" />
        <stop offset="100%" stopColor="#059669" />
      </linearGradient>
      <linearGradient id="mn-card2" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#f59e0b" />
        <stop offset="100%" stopColor="#d97706" />
      </linearGradient>
      <linearGradient id="mn-card3" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#3B5BA5" />
        <stop offset="100%" stopColor="#2563eb" />
      </linearGradient>
    </defs>
    <rect width="400" height="300" fill="url(#mn-bg)" rx="12" />

    {/* Dashboard container */}
    <rect x="30" y="20" width="340" height="260" fill="#ffffff" rx="10" stroke="#d1fae5" strokeWidth="1" />

    {/* Page title */}
    <text x="45" y="42" fontSize="12" fill="#1e293b" fontWeight="700" fontFamily="sans-serif">Payments</text>

    {/* Stat cards row */}
    {/* Total Earnings */}
    <rect x="45" y="55" width="95" height="55" rx="8" fill="url(#mn-card1)" />
    <text x="55" y="72" fontSize="7" fill="#fff" fillOpacity="0.8" fontFamily="sans-serif">Total Earnings</text>
    <text x="55" y="92" fontSize="16" fill="#fff" fontWeight="700" fontFamily="sans-serif">₱48,500</text>

    {/* Pending */}
    <rect x="152" y="55" width="95" height="55" rx="8" fill="url(#mn-card2)" />
    <text x="162" y="72" fontSize="7" fill="#fff" fillOpacity="0.8" fontFamily="sans-serif">Pending</text>
    <text x="162" y="92" fontSize="16" fill="#fff" fontWeight="700" fontFamily="sans-serif">₱12,000</text>

    {/* Available */}
    <rect x="259" y="55" width="95" height="55" rx="8" fill="url(#mn-card3)" />
    <text x="269" y="72" fontSize="7" fill="#fff" fillOpacity="0.8" fontFamily="sans-serif">Available</text>
    <text x="269" y="92" fontSize="16" fill="#fff" fontWeight="700" fontFamily="sans-serif">₱36,500</text>

    {/* Payment History header */}
    <text x="45" y="135" fontSize="9" fill="#64748b" fontWeight="600" fontFamily="sans-serif">Payment History</text>
    <line x1="45" y1="142" x2="355" y2="142" stroke="#e2e8f0" strokeWidth="1" />

    {/* Payment row 1 */}
    <rect x="45" y="150" width="310" height="28" rx="6" fill="#f8fafc" />
    <circle cx="60" cy="164" r="8" fill="#10b981" />
    <text x="60" y="167" fontSize="8" fill="#fff" fontWeight="700" textAnchor="middle" fontFamily="sans-serif">₱</text>
    <rect x="76" y="158" width="90" height="5" rx="2.5" fill="#1e293b" />
    <rect x="76" y="167" width="60" height="4" rx="2" fill="#94a3b8" />
    <rect x="280" y="160" width="60" height="10" rx="5" fill="#d1fae5" />
    <text x="310" y="167" fontSize="7" fill="#059669" fontWeight="600" textAnchor="middle" fontFamily="sans-serif">Completed</text>

    {/* Payment row 2 */}
    <rect x="45" y="184" width="310" height="28" rx="6" fill="#f8fafc" />
    <circle cx="60" cy="198" r="8" fill="#f59e0b" />
    <text x="60" y="201" fontSize="8" fill="#fff" fontWeight="700" textAnchor="middle" fontFamily="sans-serif">₱</text>
    <rect x="76" y="192" width="80" height="5" rx="2.5" fill="#1e293b" />
    <rect x="76" y="201" width="55" height="4" rx="2" fill="#94a3b8" />
    <rect x="280" y="194" width="60" height="10" rx="5" fill="#fef3c7" />
    <text x="310" y="201" fontSize="7" fill="#d97706" fontWeight="600" textAnchor="middle" fontFamily="sans-serif">Processing</text>

    {/* Payment row 3 */}
    <rect x="45" y="218" width="310" height="28" rx="6" fill="#f8fafc" />
    <circle cx="60" cy="232" r="8" fill="#3B5BA5" />
    <text x="60" y="235" fontSize="8" fill="#fff" fontWeight="700" textAnchor="middle" fontFamily="sans-serif">₱</text>
    <rect x="76" y="226" width="85" height="5" rx="2.5" fill="#1e293b" />
    <rect x="76" y="235" width="50" height="4" rx="2" fill="#94a3b8" />
    <rect x="280" y="228" width="60" height="10" rx="5" fill="#dbeafe" />
    <text x="310" y="235" fontSize="7" fill="#3B5BA5" fontWeight="600" textAnchor="middle" fontFamily="sans-serif">Pending</text>

    {/* Payment methods footer */}
    <rect x="45" y="256" width="310" height="16" rx="4" fill="#f1f5f9" />
    <text x="55" y="267" fontSize="7" fill="#64748b" fontFamily="sans-serif">GCash · Bank Transfer · PayPal</text>
  </svg>
);

// Feature 3: Connect with Brands — campaign browse grid with filters
// Mirrors the actual influencer Campaigns browse page
export const ConnectBrandsSVG = () => (
  <svg viewBox="0 0 400 300" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <defs>
      <linearGradient id="cb-bg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#faf5ff" />
        <stop offset="100%" stopColor="#f5f3ff" />
      </linearGradient>
      <linearGradient id="cb-img1" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#8b5cf6" />
        <stop offset="100%" stopColor="#a78bfa" />
      </linearGradient>
      <linearGradient id="cb-img2" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#3B5BA5" />
        <stop offset="100%" stopColor="#60A5FA" />
      </linearGradient>
      <linearGradient id="cb-img3" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#f59e0b" />
        <stop offset="100%" stopColor="#fbbf24" />
      </linearGradient>
    </defs>
    <rect width="400" height="300" fill="url(#cb-bg)" rx="12" />

    {/* Page container */}
    <rect x="25" y="20" width="350" height="260" fill="#ffffff" rx="10" stroke="#ede9fe" strokeWidth="1" />

    {/* Page title */}
    <text x="40" y="42" fontSize="12" fill="#1e293b" fontWeight="700" fontFamily="sans-serif">Browse Campaigns</text>

    {/* Filter bar */}
    <rect x="40" y="52" width="70" height="20" rx="6" fill="#f3e8ff" />
    <text x="75" y="65" fontSize="8" fill="#7c3aed" fontWeight="600" textAnchor="middle" fontFamily="sans-serif">All Categories</text>
    <rect x="118" y="52" width="60" height="20" rx="6" fill="#f3e8ff" />
    <text x="148" y="65" fontSize="8" fill="#7c3aed" fontWeight="600" textAnchor="middle" fontFamily="sans-serif">All Types</text>
    <rect x="186" y="52" width="50" height="20" rx="6" fill="#ede9fe" />
    <text x="211" y="65" fontSize="8" fill="#7c3aed" fontWeight="600" textAnchor="middle" fontFamily="sans-serif">Sort</text>

    {/* Campaign card 1 */}
    <rect x="40" y="82" width="100" height="130" rx="8" fill="#ffffff" stroke="#e2e8f0" strokeWidth="1" />
    <rect x="40" y="82" width="100" height="50" fill="url(#cb-img1)" rx="8" />
    <rect x="40" y="120" width="100" height="12" fill="url(#cb-img1)" />
    <rect x="48" y="90" width="40" height="14" rx="7" fill="#fff" fillOpacity="0.25" />
    <text x="68" y="100" fontSize="7" fill="#fff" fontWeight="600" textAnchor="middle" fontFamily="sans-serif">Beauty</text>
    <rect x="48" y="140" width="70" height="5" rx="2.5" fill="#1e293b" />
    <rect x="48" y="150" width="55" height="4" rx="2" fill="#94a3b8" />
    <rect x="48" y="160" width="60" height="4" rx="2" fill="#e2e8f0" />
    <rect x="48" y="170" width="45" height="4" rx="2" fill="#e2e8f0" />
    <rect x="48" y="185" width="40" height="16" rx="4" fill="#d1fae5" />
    <text x="68" y="196" fontSize="7" fill="#059669" fontWeight="600" textAnchor="middle" fontFamily="sans-serif">₱1,500</text>
    <rect x="94" y="185" width="38" height="16" rx="4" fill="#f1f5f9" />
    <text x="113" y="196" fontSize="6" fill="#64748b" fontWeight="600" textAnchor="middle" fontFamily="sans-serif">5 spots</text>

    {/* Campaign card 2 */}
    <rect x="150" y="82" width="100" height="130" rx="8" fill="#ffffff" stroke="#e2e8f0" strokeWidth="1" />
    <rect x="150" y="82" width="100" height="50" fill="url(#cb-img2)" rx="8" />
    <rect x="150" y="120" width="100" height="12" fill="url(#cb-img2)" />
    <rect x="158" y="90" width="36" height="14" rx="7" fill="#fff" fillOpacity="0.25" />
    <text x="176" y="100" fontSize="7" fill="#fff" fontWeight="600" textAnchor="middle" fontFamily="sans-serif">Food</text>
    <rect x="158" y="140" width="65" height="5" rx="2.5" fill="#1e293b" />
    <rect x="158" y="150" width="50" height="4" rx="2" fill="#94a3b8" />
    <rect x="158" y="160" width="55" height="4" rx="2" fill="#e2e8f0" />
    <rect x="158" y="170" width="40" height="4" rx="2" fill="#e2e8f0" />
    <rect x="158" y="185" width="40" height="16" rx="4" fill="#d1fae5" />
    <text x="178" y="196" fontSize="7" fill="#059669" fontWeight="600" textAnchor="middle" fontFamily="sans-serif">Product</text>
    <rect x="204" y="185" width="38" height="16" rx="4" fill="#fef2f2" />
    <text x="223" y="196" fontSize="6" fill="#dc2626" fontWeight="600" textAnchor="middle" fontFamily="sans-serif">2 left</text>

    {/* Campaign card 3 */}
    <rect x="260" y="82" width="100" height="130" rx="8" fill="#ffffff" stroke="#e2e8f0" strokeWidth="1" />
    <rect x="260" y="82" width="100" height="50" fill="url(#cb-img3)" rx="8" />
    <rect x="260" y="120" width="100" height="12" fill="url(#cb-img3)" />
    <rect x="268" y="90" width="44" height="14" rx="7" fill="#fff" fillOpacity="0.25" />
    <text x="290" y="100" fontSize="7" fill="#fff" fontWeight="600" textAnchor="middle" fontFamily="sans-serif">Fitness</text>
    <rect x="268" y="140" width="60" height="5" rx="2.5" fill="#1e293b" />
    <rect x="268" y="150" width="48" height="4" rx="2" fill="#94a3b8" />
    <rect x="268" y="160" width="52" height="4" rx="2" fill="#e2e8f0" />
    <rect x="268" y="170" width="38" height="4" rx="2" fill="#e2e8f0" />
    <rect x="268" y="185" width="40" height="16" rx="4" fill="#d1fae5" />
    <text x="288" y="196" fontSize="7" fill="#059669" fontWeight="600" textAnchor="middle" fontFamily="sans-serif">₱3,000</text>
    <rect x="314" y="185" width="38" height="16" rx="4" fill="#f1f5f9" />
    <text x="333" y="196" fontSize="6" fill="#64748b" fontWeight="600" textAnchor="middle" fontFamily="sans-serif">8 spots</text>

    {/* Pagination */}
    <circle cx="180" cy="235" r="4" fill="#8b5cf6" />
    <circle cx="195" cy="235" r="4" fill="#e2e8f0" />
    <circle cx="210" cy="235" r="4" fill="#e2e8f0" />
    <text x="200" y="258" fontSize="7" fill="#94a3b8" textAnchor="middle" fontFamily="sans-serif">Page 1 of 3</text>
  </svg>
);

// Feature 4: Direct Communication — messaging interface
// Mirrors the actual influencer Messages page with conversation list + chat
export const DirectCommSVG = () => (
  <svg viewBox="0 0 400 300" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <defs>
      <linearGradient id="dc-bg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#fffbeb" />
        <stop offset="100%" stopColor="#fefce8" />
      </linearGradient>
      <linearGradient id="dc-sidebar" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stopColor="#f8fafc" />
        <stop offset="100%" stopColor="#f1f5f9" />
      </linearGradient>
    </defs>
    <rect width="400" height="300" fill="url(#dc-bg)" rx="12" />

    {/* Messages container */}
    <rect x="25" y="20" width="350" height="260" fill="#ffffff" rx="10" stroke="#fef3c7" strokeWidth="1" />

    {/* Page title */}
    <text x="40" y="42" fontSize="12" fill="#1e293b" fontWeight="700" fontFamily="sans-serif">Messages</text>

    {/* Conversation sidebar */}
    <rect x="35" y="52" width="120" height="218" rx="6" fill="url(#dc-sidebar)" />

    {/* Search bar */}
    <rect x="42" y="60" width="106" height="18" rx="6" fill="#ffffff" stroke="#e2e8f0" strokeWidth="1" />
    <circle cx="52" cy="69" r="3" fill="none" stroke="#94a3b8" strokeWidth="1.5" />
    <line x1="54" y1="71" x2="56" y2="73" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" />
    <rect x="60" y="66" width="50" height="4" rx="2" fill="#cbd5e1" />

    {/* Conversation 1 (active) */}
    <rect x="42" y="84" width="106" height="32" rx="6" fill="#3B5BA5" fillOpacity="0.1" />
    <circle cx="54" cy="100" r="10" fill="#f59e0b" />
    <text x="54" y="103" fontSize="8" fill="#fff" fontWeight="700" textAnchor="middle" fontFamily="sans-serif">B</text>
    <rect x="70" y="92" width="60" height="4" rx="2" fill="#1e293b" />
    <rect x="70" y="100" width="45" height="3" rx="1.5" fill="#94a3b8" />
    <circle cx="142" cy="100" r="3" fill="#3B5BA5" />

    {/* Conversation 2 */}
    <rect x="42" y="120" width="106" height="32" rx="6" fill="#ffffff" />
    <circle cx="54" cy="136" r="10" fill="#8b5cf6" />
    <text x="54" y="139" fontSize="8" fill="#fff" fontWeight="700" textAnchor="middle" fontFamily="sans-serif">B</text>
    <rect x="70" y="128" width="55" height="4" rx="2" fill="#475569" />
    <rect x="70" y="136" width="40" height="3" rx="1.5" fill="#cbd5e1" />

    {/* Conversation 3 */}
    <rect x="42" y="156" width="106" height="32" rx="6" fill="#ffffff" />
    <circle cx="54" cy="172" r="10" fill="#10b981" />
    <text x="54" y="175" fontSize="8" fill="#fff" fontWeight="700" textAnchor="middle" fontFamily="sans-serif">B</text>
    <rect x="70" y="164" width="50" height="4" rx="2" fill="#475569" />
    <rect x="70" y="172" width="38" height="3" rx="1.5" fill="#cbd5e1" />

    {/* Conversation 4 */}
    <rect x="42" y="192" width="106" height="32" rx="6" fill="#ffffff" />
    <circle cx="54" cy="208" r="10" fill="#ec4899" />
    <text x="54" y="211" fontSize="8" fill="#fff" fontWeight="700" textAnchor="middle" fontFamily="sans-serif">B</text>
    <rect x="70" y="200" width="58" height="4" rx="2" fill="#475569" />
    <rect x="70" y="208" width="42" height="3" rx="1.5" fill="#cbd5e1" />

    {/* Chat area */}
    <rect x="165" y="52" width="200" height="218" rx="6" fill="#ffffff" />

    {/* Chat header */}
    <rect x="165" y="52" width="200" height="32" rx="6" fill="#f8fafc" />
    <rect x="165" y="78" width="200" height="6" fill="#f8fafc" />
    <circle cx="178" cy="68" r="10" fill="#f59e0b" />
    <text x="178" y="71" fontSize="8" fill="#fff" fontWeight="700" textAnchor="middle" fontFamily="sans-serif">B</text>
    <rect x="194" y="63" width="70" height="5" rx="2.5" fill="#1e293b" />
    <rect x="194" y="71" width="40" height="3" rx="1.5" fill="#10b981" />
    <text x="240" y="73" fontSize="6" fill="#10b981" fontFamily="sans-serif">Online</text>

    {/* Incoming message */}
    <path d="M175 100 Q168 100 168 107 L168 130 Q168 137 175 137 L180 137 L174 144 L186 137 L260 137 Q267 137 267 130 L267 107 Q267 100 260 100 Z" fill="#f1f5f9" />
    <rect x="178" y="108" width="70" height="4" rx="2" fill="#cbd5e1" />
    <rect x="178" y="116" width="55" height="4" rx="2" fill="#e2e8f0" />
    <rect x="178" y="124" width="40" height="4" rx="2" fill="#e2e8f0" />

    {/* Outgoing message */}
    <path d="M230 155 Q223 155 223 162 L223 185 Q223 192 230 192 L300 192 Q307 192 307 185 L307 162 Q307 155 300 155 L295 155 L301 148 L289 155 Z" fill="#3B5BA5" />
    <rect x="232" y="163" width="60" height="4" rx="2" fill="#fff" fillOpacity="0.8" />
    <rect x="232" y="171" width="50" height="4" rx="2" fill="#fff" fillOpacity="0.6" />
    <rect x="232" y="179" width="35" height="4" rx="2" fill="#fff" fillOpacity="0.6" />

    {/* Incoming message short */}
    <path d="M175 205 Q168 205 168 212 L168 230 Q168 237 175 237 L180 237 L174 244 L186 237 L220 237 Q227 237 227 230 L227 212 Q227 205 220 205 Z" fill="#f1f5f9" />
    <rect x="178" y="213" width="40" height="4" rx="2" fill="#cbd5e1" />
    <rect x="178" y="221" width="30" height="4" rx="2" fill="#e2e8f0" />

    {/* Input bar */}
    <rect x="172" y="255" width="186" height="10" rx="5" fill="#f8fafc" stroke="#e2e8f0" strokeWidth="1" />
    <rect x="178" y="258" width="80" height="3" rx="1.5" fill="#cbd5e1" />
    <circle cx="350" cy="260" r="6" fill="#f59e0b" />
    <path d="M348 257 L348 263 M345 260 L351 260" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export const FeatureSVGs = {
  "Product Reviews": ProductReviewsSVG,
  "Monetize Your Influence": MonetizeSVG,
  "Connect with Brands": ConnectBrandsSVG,
  "Direct Communication": DirectCommSVG,
};
